import { graphql } from "relay-runtime"

export const deReferralLetterFragment = graphql`
  fragment deReferralLetterFragment on de_ReferralLetter {
    id
    progressNoteId
    createdAt
    createdBy
    fileId
    patientId
    reasoning
    referralId
    signedAt
    signedBy
    updatedAt
    updatedBy
    concludedAt
    concludedBy
    medicationIds
    conditions
    allergies
    icdDiagnosis {
      id
      isAssociation
      diagnosisCode
      primaryCode
      secondaryCode
      associationType
      text
    }
    progressNote {
      pointOfCare {
        pointOfCareSpecialty {
          id
          language
          synonym
          word
        }
      }
    }
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
